class FormValidator {
  form = document.querySelector('.js-form-validate')
  submitBtn = this.form.querySelector('.js-submit')
  requiredFields = this.form.querySelectorAll('input[required]')

  constructor() {
    // Check for form validation support.
    if (this.form.checkValidity === undefined) {
      return
    }

    this.checkFormValidity()

    this.requiredFields.forEach(field => {
      field.addEventListener(
        field.type === 'checkbox' ? 'change' : 'keyup',
        () => {
          this.checkFormValidity()
        }
      )
    })
  }

  checkFormValidity() {
    if (this.form.checkValidity()) {
      this.submitBtn.removeAttribute('disabled')
    } else {
      this.submitBtn.setAttribute('disabled', true)
    }
  }
}

document.addEventListener('turbolinks:load', function () {
  if (document.querySelector('.js-form-validate')) {
    new FormValidator()
  }
})
